declare var require: any;
import { cnpj, cpf } from "cpf-cnpj-validator";
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
const htmlToPdfmake = require("html-to-pdfmake");
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

export class PDF {
  host = window.location.protocol + "//" + window.location.host;

  header() {
    return `
            <table class="table" data-pdfmake="{'widths':[100,'*','auto']}">
                <tbody>
                    <tr>
                        <td style="border: 1px solid #fff"><img src="${this.host}/assets/images/serasa/logo-teddy-pdf.png" style="width: 100px"></td>
                        <td style="border: 1px solid #fff"></td>
                        <td style="border: 1px solid #fff"><img src="${this.host}/assets/images/serasa/logo-serasa-pdf.png" style="width: 100px"></td>
                    </tr>
                </tbody>
            </table>
        `;
  }

  infoCNPJ(date: Date, companyDocument: string, companyName: string, foundationDate: string) {
    let dateFormat = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    let foundationDateFormat: any = foundationDate.split("-");
    foundationDateFormat = foundationDateFormat[2] + "/" + foundationDateFormat[1] + "/" + foundationDateFormat[0];

    return `
            <table class="table" data-pdfmake="{'widths':[100,'*','auto']}">
                <tbody>
                    <tr>
                        <td colspan="3" style="border: 1px solid #F3F3F3">
                            Resumo da Consulta em ${dateFormat}
                        </td>
                    </tr>
                    <tr>
                    <td colspan="3" style="border: 1px solid #F3F3F3">
                        CNPJ: <span style="color: #C5381A">${
                          companyDocument.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") ||
                          "Não Possui"
                        }</span>
                    </td>
                </tr>
                    <tr>
                        <td colspan="3" style="border: 1px solid #F3F3F3">Nome: ${companyName || "Não Possui"}</td>
                    </tr>
                    <tr>
                        <td colspan="3" style="border: 1px solid #F3F3F3">Data de Fundação: ${
                          foundationDateFormat || "Não Possui"
                        }</td>
                    </tr>
                </tbody>
            </table>
       `;
  }

  infoCPF(date: any, name: string, document: string, motherName: string, birthDate: string) {
    let dateFormat = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    let birthDateFormat: any = birthDate.split("-");
    birthDateFormat = birthDateFormat[2] + "/" + birthDateFormat[1] + "/" + birthDateFormat[0];

    return `
        <table class="table" data-pdfmake="{'widths':[100,'*','auto']}">
            <tbody>
                <tr>
                    <td colspan="3" style="border: 1px solid #F3F3F3">
                        Resumo da Consulta em ${dateFormat || "Não Possui"}
                    </td>
                </tr>
                <tr>
                    <td colspan="3" style="border: 1px solid #F3F3F3">
                        CPF: <span style="color: #C5381A">${
                          document.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4") || "Não Possui"
                        }</span>
                    </td>
                </tr>
                <tr>
                   <td>Nome: ${name || "Não Possui"}</td>
                </tr>
                <tr>
                   <td>Nome da Mãe: ${motherName || "Não Possui"}</td>
                </tr>
                <tr>
                   <td>Data de Nascimento: ${birthDateFormat || "Não Possui"}</td>
                </tr>
            </tbody>
        </table>`;
  }

  score(score: string) {
    return ` 
            <table class="table" data-pdfmake="{'widths':[100,'*','auto']}">
                <tbody>
                    <tr>
                        <td colspan="3" style="border: 1px solid #C5381A; background-color: #fcf6f4">
                            Serasa score: <span style="color: #C5381A">${score || "Não Possui"}</span>
                            <br>
                            scoreMessage
                        </td>
                    </tr>
                </tbody>
            </table>
        `;
  }

  generalTable(data: any) {
    const checkQuantity = data?.negativeData?.check?.summary?.count;
    const checkBalance = data?.negativeData?.check?.summary?.balance;
    const checkLastOccurrence = data?.negativeData?.check?.summary?.lastOccurrence;

    const pefinQuantity = data?.negativeData?.pefin?.summary?.count;
    const pefinBalance = data?.negativeData?.pefin?.summary?.balance;
    const pefinLastOccurrence = data?.negativeData?.pefin?.summary?.lastOccurrence;

    const refinQuantity = data?.negativeData?.refin?.summary?.count;
    const refinBalance = data?.negativeData?.refin?.summary?.balance;
    const refinLastOccurrence = data?.negativeData?.refin?.summary?.lastOccurrence;

    const notaryQuantity = data?.negativeData?.notary?.summary?.count;
    const notaryBalance = data?.negativeData?.notary?.summary?.balance;
    const notaryLastOccurrence = data?.negativeData?.notary?.summary?.lastOccurrence;

    const inquiryQuantity = data?.facts?.inquiryCompanyResponse?.quantity?.historical.reduce(
      (acc, item) => {
        return acc + item.occurrences;
      },
      data?.facts?.inquiryCompanyResponse?.quantity?.actual
    );

    const convemQuantity = data?.negativeData?.collectionRecords?.summary?.count;
    const convemBalance = data?.negativeData?.collectionRecords?.summary?.balance;
    const convemLastOccurrence = data?.negativeData?.collectionRecords?.summary?.lastOccurrence;

    const allDataLastOccurrenceArr = [convemLastOccurrence, pefinLastOccurrence, refinLastOccurrence].filter(
      item => !!item
    );

    function mostRecentDate(dateArray) {
      if (dateArray.length) {
        const dates = dateArray.map(dateStr => new Date(dateStr));
        const maxDate = new Date(Math.max.apply(null, dates));
        const formattedDate = maxDate.toISOString().slice(0, 10);
        return formattedDate;
      }
      return false;
    }
    let allDataLastOccurrenceFormat: any;
    if (!!mostRecentDate(allDataLastOccurrenceArr)) {
      const allDataLastOccurrence: any = mostRecentDate(allDataLastOccurrenceArr);
      allDataLastOccurrenceFormat = allDataLastOccurrence.split("-");
      allDataLastOccurrenceFormat =
        allDataLastOccurrenceFormat[2] + "/" + allDataLastOccurrenceFormat[1] + "/" + allDataLastOccurrenceFormat[0];
    }
    return `<table class="table" data-pdfmake="{'widths':[120,129,129,100]}">
        <tbody>
           <tr>
              <th style="border: 1px solid #F3F3F3;color: black;font-size: 16px;background-color: #F3F3F3;text-align: left"> <strong>Ocorrências</strong> </th>
              <th style="border: 1px solid #F3F3F3;color: black; font-size: 16px;background-color: #F3F3F3;text-align: left"> <strong>Quantidade</strong> </th>
              <th style="border: 1px solid #F3F3F3;color: black; font-size: 16px;background-color: #F3F3F3;text-align: left"> <strong>Valor</strong> </th>
              <th style="border: 1px solid #F3F3F3;color: black; font-size: 16px;background-color: #F3F3F3;text-align: left"> <strong>Último Registro</strong> </th>
           </tr>
           <tr>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> Cheques sem fundos </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> ${checkQuantity || "Não Possui"} </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> R$ ${
                checkBalance.toLocaleString("pt-br", {
                  minimumFractionDigits: 2
                }) || "Não Existe"
              } </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> ${checkLastOccurrence || "Não Possui"} </td>
           </tr>
           <tr>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> PEFIN, REFIN e dívidas vencidas </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> ${
                pefinQuantity + refinQuantity + convemQuantity || "Não Possui"
              } </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> R$ ${
                (pefinBalance + refinBalance + convemBalance).toLocaleString("pt-br", { minimumFractionDigits: 2 }) ||
                "Não Possui"
              } </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> ${
                allDataLastOccurrenceFormat || "Não Possui"
              } </td>
           </tr>
           <tr>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> Protesto Estadual </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> ${notaryQuantity || "Não Possui"} </td>
              <td style="border: 1px solid #F3F3F3;font-size: 14px"> R$ ${
                notaryBalance.toLocaleString("pt-br", {
                  minimumFractionDigits: 2
                }) || "Não Posssui"
              } </td>
              <td style="border: 1px solid #F3F3F3"> ${notaryLastOccurrence || "Não Possui"} </td>
           </tr>
           <tr>
              <td style="border: 1px solid #F3F3F3; font-size: 14px"> Registro de consultas </td>
              <td style="border: 1px solid #F3F3F3; font-size: 14px"> ${inquiryQuantity || "Não Possui"} </td>
              <td style="border: 1px solid #F3F3F3; font-size: 14px"> Não Possui </td>
              <td style="border: 1px solid #F3F3F3"> Não Possui </td>
           </tr>
        </tbody>
     </table>`;
  }

  stateProtest(data: any) {
    const { count, balance, lastOccurrence, firstOccurrence } = data.negativeData.notary.summary;

    if (data.negativeData.notary.notaryResponse) {
      let rows = "";

      data.negativeData.notary.notaryResponse.forEach(item => {
        rows += `<tr> <td style="border: 1px solid #F3F3F3; font-size: 14px">${
          item.occurrenceDate || "Não Possui"
        }</td> <td style="border: 1px solid #F3F3F3; font-size: 14px">R$ ${
          item.amount || "Não Possui"
        }</td> <td style="border: 1px solid #F3F3F3; font-size: 14px">${
          item.officeNumber || "Não Possui"
        }</td> <td style="border: 1px solid #F3F3F3; font-size: 14px">${
          item.city || "Não Possui"
        }</td> <td style="border: 1px solid #F3F3F3; font-size: 14px">${item.federalUnit || "Não Possui"}</td> </tr>`;
      });

      return `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <th colspan="3" style="border: 1px solid #F3F3F3; background-color: #F3F3F3; color: black"><strong>Protesto Estadual</strong></th> </tr> <tr> <td colspan="3" style="border: 1px solid #F3F3F3">Total de ocorrências: ${
        count || "Não Possui"
      } ocorrência(s)</td> </tr> <tr> <td colspan="3" style="border: 1px solid #F3F3F3">Período de ${
        firstOccurrence || "Não Possui"
      } - ${
        lastOccurrence || "Não Possui"
      }</td> </tr> <tr> <td colspan="3" style="border: 1px solid #F3F3F3">Valor total das ocorrências: R$ ${
        balance || "Não Possui"
      }</td> </tr> <tr> <td colspan="3" style="border: 1px solid #F3F3F3">Últimas ocorrências</td> </tr> </tbody> </table> <table class="table" style="margin-bottom: 0; margin-top:0" data-pdfmake="{'widths':[100,100,100,100,'*']}"> <tbody> <tr> <td style="border: 1px solid #F3F3F3;border-top: 1px solid #fff; font-size: 14px">Data</td> <td style="border: 1px solid #F3F3F3;border-top: 1px solid #fff; font-size: 14px">Valor</td> <td style="border: 1px solid #F3F3F3;border-top: 1px solid #fff; font-size: 14px">Cartório</td> <td style="border: 1px solid #F3F3F3;border-top: 1px solid #fff; font-size: 14px">Cidade</td> <td style="border: 1px solid #F3F3F3; font-size: 14px; border-top: 1px solid #fff;">UF</td> </tr> ${rows} </tbody> </table>`;
    } else {
      return `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <th colspan="3" style="border: 1px solid #F3F3F3; background-color: #F3F3F3; color: black"><strong>Protesto Estadual</strong></th> </tr> <tr> <td colspan="3" style="border: 1px solid #F3F3F3; color: #00d071">Nada Consta</td> </tr> </tbody> </table>`;
    }
  }

  badChecks(data: any) {
    let rows = "";

    if (data.negativeData.check.length) {
      const { balance, count, firstOccurrence, lastOccurrence } = data.negativeData.check.summary;

      let firstOccurrenceFormat = firstOccurrence.split("-");
      firstOccurrenceFormat =
        firstOccurrenceFormat[2] + "/" + firstOccurrenceFormat[1] + "/" + firstOccurrenceFormat[0];

      let lastOccurrenceFormat = lastOccurrence.split("-");
      lastOccurrenceFormat = lastOccurrenceFormat[2] + "/" + lastOccurrenceFormat[1] + "/" + lastOccurrenceFormat[0];

      rows += `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[250,'*']}"> <tbody> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Data da negativação mais recente: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        firstOccurrenceFormat || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Data da negativação mais antiga: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        lastOccurrenceFormat || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Quantidade total de cheques sem fundo: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        count || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Valor total de cheques sem fundo </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> R$ ${
        balance.toLocaleString("pt-br", { minimumFractionDigits: 2 }) || "Não Possui"
      } </td> </tr> </tbody> </table>`;

      data.negativeData.check.forEach(item => {
        let dateFormat = item.occurrenceDate.split("-");
        dateFormat = dateFormat[2] + "/" + dateFormat[1] + "/" + dateFormat[0];

        rows += `<table class="table" data-pdfmake="{'widths':[250,246]}"> <tbody> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Data da ocorrência:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          dateFormat || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Identificador do motivo da devolução do cheque:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.alinea || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Nº agência</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.bankAgencyId || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Número do cheque</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.checkNumber || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Cidade:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.city || "Não possui"
        }</td> </tr> </tbody> </table>`;
      });
    } else {
      rows += `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <td colspan="3" style="border: 1px solid #F3F3F3; color: #00d071"> Nada Consta </td> </tr> </tbody> </table>`;
    }

    return `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <th colspan="3" style="border: 1px solid #F3F3F3; background-color: #F3F3F3; color: black"> Cheques sem fundos </th> </tr> </tbody> </table>${rows}`;
  }

  pefin(data: any) {
    let rows = "";
    if (data?.negativeData?.pefin?.pefinResponse?.length) {
      const { balance, count, firstOccurrence, lastOccurrence } = data.negativeData.pefin.summary;

      let firstOccurrenceFormat = firstOccurrence.split("-");
      firstOccurrenceFormat =
        firstOccurrenceFormat[2] + "/" + firstOccurrenceFormat[1] + "/" + firstOccurrenceFormat[0];

      let lastOccurrenceFormat = lastOccurrence.split("-");
      lastOccurrenceFormat = lastOccurrenceFormat[2] + "/" + lastOccurrenceFormat[1] + "/" + lastOccurrenceFormat[0];

      rows += `<table class="table" data-pdfmake="{'widths':[250,'*']}"> <tbody> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Data da negativação mais recente </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        firstOccurrenceFormat || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Data da negativação mais antiga: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        lastOccurrenceFormat || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Quantidade total de pendências financeiras: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        count || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Valor total de pendências financeiras: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> R$ ${
        balance.toLocaleString("pt-br", { minimumFractionDigits: 2 }) || "Não Possui"
      } </td> </tr> </tbody> </table>`;

      data.negativeData.pefin.pefinResponse.forEach(item => {
        let dateFormat = item.occurrenceDate.split("-");
        dateFormat = dateFormat[2] + "/" + dateFormat[1] + "/" + dateFormat[0];

        rows += `<table class="table" data-pdfmake="{'widths':[250,246]}"> <tbody> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Data da ocorrência:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          dateFormat || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Identificador da natureza da dívida:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.legalNatureId || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Natureza da dívida:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.legalNature || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Identificador do contrato:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.contractId || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Nome do credor:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.creditorName || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Valor da dívida:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">R$ ${
          item.amount.toLocaleString("pt-br", { minimumFractionDigits: 2 }) || "Não possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Estado:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.federalUnit || "Não Possui"
        }</td> </tr> <tbody> </table>`;
      });
    } else {
      rows += `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <td colspan="3" style="border: 1px solid #F3F3F3; color: #00d071"> Nada Consta </td> </tr> </tbody> </table>`;
    }

    return `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <th colspan="3" style="border: 1px solid #F3F3F3; background-color: #F3F3F3; color: black"> Pendência Financeira - PEFIN </th> </tr> </tbody> </table>${rows}`;
  }

  refin(data: any) {
    let rows = "";

    if (data.negativeData.refin.refinResponse) {
      const { balance, count, firstOccurrence, lastOccurrence } = data.negativeData.refin.summary;

      let firstOccurrenceFormat = firstOccurrence.split("-");
      firstOccurrenceFormat =
        firstOccurrenceFormat[2] + "/" + firstOccurrenceFormat[1] + "/" + firstOccurrenceFormat[0];

      let lastOccurrenceFormat = lastOccurrence.split("-");
      lastOccurrenceFormat = lastOccurrenceFormat[2] + "/" + lastOccurrenceFormat[1] + "/" + lastOccurrenceFormat[0];

      rows += `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[250,'*']}"> <tbody> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Data da negativação mais recente </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        firstOccurrenceFormat || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Data da negativação mais antiga: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        lastOccurrenceFormat || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Quantidade total de restrições financeiras: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> ${
        count || "Não Possui"
      } </td> </tr> <tr> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> Valor total de restrições financeiras: </td> <td style="border: 1px solid #F3F3F3;fonte-size: 14px"> R$ ${
        balance.toLocaleString("pt-br", { minimumFractionDigits: 2 }) || "Não Possui"
      } </td> </tr> </tbody> </table>`;

      data.negativeData.refin.refinResponse.forEach(item => {
        let dateFormat = item.occurrenceDate.split("-");
        dateFormat = dateFormat[2] + "/" + dateFormat[1] + "/" + dateFormat[0];

        rows += `<table class="table" data-pdfmake="{'widths':[250,246]}"> <tbody> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Data da ocorrência:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          dateFormat || "Não Possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Identificador da natureza da dívida:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.legalNatureId || "Não Possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Natureza da dívida:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.legalNature || "Não Possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Identificador do contrato:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.contractId || "Não Possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Nome do credor:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.creditorName || "Não Possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Valor da dívida:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.amount || "Não Possui"
        }</td> </tr> <tr> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">Estado:</td> <td style="border: 1px solid #F3F3F3; color: black; font-size: 14px;">${
          item.federalUnit || "Não Possui"
        }</td> </tr> </tbody> </table>`;
      });
    } else {
      rows += `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <td colspan="3" style="border: 1px solid #F3F3F3; color: #00d071"> Nada Consta </td> </tr> </tbody> </table>`;
    }

    return `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <th colspan="3" style="border: 1px solid #F3F3F3; background-color: #F3F3F3; color: black"> Restrições Financeiras - REFIN </th> </tr> </tbody> </table>${rows}`;
  }

  retailInquiries(data: any) {
    const document = data.registration.companyDocument.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      "$1.$2.$3/$4-$5"
    );
    const lastFortnight = data.facts.inquiryCompanyResponse.quantity.actual;
    const lastMonth = data.facts.inquiryCompanyResponse.quantity.historical[0].occurrences;

    return `<table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"><tbody><tr><td colspan="3" style="border: 1px solid #F3F3F3; font-size: 14px">Consultas Varejo à Serasa realizadas ao mesmo documento</td></tr></tbody></table><table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[80,80,80,'*']}"><tbody> <tr> <td style="border: 1px solid #F3F3F3; border-top: 1px solid #fff; border-bottom: 1px solid #fff; font-size: 14px">Até 15 dias: 0</td> <td style="border: 1px solid #F3F3F3; border-top: 1px solid #fff; border-bottom: 1px solid #fff; font-size: 14px">16-30 dias: ${
      lastFortnight || "0"
    }</td> <td style="border: 1px solid #F3F3F3; border-top: 1px solid #fff; border-bottom: 1px solid #fff; font-size: 14px">31-60 dias: ${
      lastMonth || "0"
    }</td> <td style="border: 1px solid #F3F3F3; border-top: 1px solid #fff; border-bottom: 1px solid #fff; font-size: 14px">61-90 dias: 0</td> </tr> </tbody> </table><table class="table" style="margin-bottom: 0" data-pdfmake="{'widths':[100,'*','auto']}"> <tbody> <tr> <td colspan="3" style="border: 1px solid #F3F3F3;background-color: #F3F3F3; font-size: 10px">Simples consulta ao cnpj (${
      document || "Não Possui"
    }) no cadastro da Serasa. Essa informação de consulta não significa negócio realizado, nem se confunde com anotação negativa no cadastro de inadimplentes.</td> </tr> </tbody></table>`;
  }

  warning() {
    return `
            <table class="table" data-pdfmake="{'widths':[100,'*','auto']}">
                <tbody>
                    <tr>
                        <td colspan="3" style="border: 1px solid #F3F3F3; font-size: 14px">
                            Atenção
                        </td>
                    </tr>
                    <tr>
                        <td colspan="3" style="border: 1px solid #F3F3F3; background-color: #F3F3F3;font-size: 10px">
                            A decisão da aprovação ou não do crédito, é de exclusiva responsabilidade do concedente. As informações prestadas pela Serasa Experian têm como objetivo subsidiar essas decisões e, em hipótese alguma, devem ser utilizadas como justificativa, pelo concedente do crédito, para a tomada da referida decisão.
                        </td>
                    </tr>
                </tbody>
            </table>
        `;
  }

  footer() {
    return `
        <table class="table" data-pdfmake="{'widths':[216,280]}">
            <tbody>
                <tr>
                    <td style="border: 1px solid #F3F3F3; font-size: 14px; text-align: left; border-right: 1px solid #fff">
                      
                    </td>
                    <td style="border: 1px solid #F3F3F3; font-size: 14px; text-align: right">
                       2023 Serasa Experian. Todos os direitos reservados.
                    </td>
                </tr>
            </tbody>
        </table>
      `;
  }

  getData(data: any) {
    return data.reports[0];
  }

  structurePDF(data: any) {
    const header = this.header();
    const generalTable = this.generalTable(this.getData(data));
    const stateProtest = this.stateProtest(this.getData(data));
    const badChecks = this.badChecks(this.getData(data));
    const pefin = this.pefin(this.getData(data));
    const refin = this.refin(this.getData(data));
    const retailInquiries = this.retailInquiries(this.getData(data));
    const warning = this.warning();
    const footer = this.footer();

    //generate with cpf
    if (cpf.isValid(this.getData(data).registration.documentNumber)) {
      const infoCNPJ = this.infoCPF(
        new Date(),
        this.getData(data).registration.documentNumber,
        this.getData(data).registration.consumerName,
        this.getData(data).registration.motherName,
        this.getData(data).registration.birthDate
      );

      return `
            <div id="pdfTable" #pdfTable>
               ${header}
               ${infoCNPJ}
               ${generalTable}
               ${stateProtest}
               ${badChecks}
               ${pefin}
               ${refin}
               ${retailInquiries}
               ${warning}
               ${footer}
            </div>
           `;
    }

    //generate with cnpj
    if (cnpj.isValid(this.getData(data).registration.companyDocument)) {
      const infoCPF = this.infoCNPJ(
        new Date(),
        this.getData(data).registration.companyDocument,
        this.getData(data).registration.companyName,
        this.getData(data).registration.foundationDate
      );

      return `
            <div id="pdfTable" #pdfTable>
               ${header}
               ${infoCPF}
               ${generalTable}
               ${stateProtest}
               ${badChecks}
               ${pefin}
               ${refin}
               ${retailInquiries}
               ${warning}
               ${footer}
            </div>
           `;
    }

    return new Error("Número do CPF ou CNPJ inválido");
  }

  downloadPDF(data: any) {
    let html = htmlToPdfmake(this.structurePDF(data), {
      imagesByReference: true,
      defaultStyles: {
        th: {
          margin: [5, 5, 5, 5]
        }
      }
    });

    var dd = {
      content: html.content,
      images: html.images
    };

    pdfMake.createPdf(dd).download();
  }
}
